import { ToggleTheme } from "@/features/toggle-theme"
import { Outlet } from "react-router-dom"
import styles from "./styles.module.scss"

const UiAuthLayoutHeader = () => {
  return (
    <header className={styles.header}>
      <div className={styles.header__left}></div>

      <div className={styles.header__right}>
        <div>
          <ToggleTheme />
        </div>
      </div>
    </header>
  )
}

export const LayoutAuth = () => {
  return (
    <main className={styles.main}>
      <UiAuthLayoutHeader />

      <div className={styles.main__content}>
        <Outlet />
      </div>
    </main>
  )
}
